import devConfig from './config.dev';
import prodConfig from './config.prod';
import testConfig from './config.test';
import baseConfig from './config.base';

const env = process.env.NODE_ENV;
const config = env === 'development' ? devConfig : (env !== 'production' ? testConfig : prodConfig);
export default Object.assign(baseConfig, config);
